import { useCallback, useEffect, useState } from "react";
import { useOnUpdateUserEvents } from "../../../hooks/firestoreHooks/eventListUpdateHook";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { ROUTE_QUERY_CONSTANTS } from "../../../routes";
import {
  getEventRequestThunk,
  getEventsThunk,
} from "../../../store/events/eventThunk";
import { EVENT_TYPE } from "../../../types/eventTypes";
import EventGrid from "../EventGrid";
import { GridIdsEnum, GridTypesEnum } from "../../../constants/enums";

const AIDirectRequest = () => {
  const dispatch = useAppDispatch();
  const [shouldStartUpdating, setShouldStartUpdating] = useState(false);
  const fetchEventListData = useCallback(async () => {
    dispatch(
      getEventsThunk({
        type: EVENT_TYPE.AI_DIRECT_REQUEST,
        isLoading: false,
      })
    );
    dispatch(getEventRequestThunk(null));
  }, [dispatch]);

  useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

  useEffect(() => {
    const getData = async () => {
      await dispatch(
        getEventsThunk({
          type: EVENT_TYPE.AI_DIRECT_REQUEST,
          isLoading: true,
        })
      );
      await dispatch(getEventRequestThunk(null));
      setShouldStartUpdating(true);
    };
    getData();
  }, []);

  return (
    <EventGrid
      gridId={GridIdsEnum.EventAiDirectRequests}
      eventType={GridTypesEnum.AiDirectRequest}
      showSave={false}
      showPrepaid
      title={"AI Direct Requests"}
      queryParams={ROUTE_QUERY_CONSTANTS.AiDirectRequest}
    />
  );
};

export default AIDirectRequest;
